module.exports = new __parcel__URL__("ww-animated-on-air-navigation.0ae2e4df.gif").toString();